import React, { useState } from "react";
import {
  Avatar,
  Menu,
  MenuItem,
  Typography,
  IconButton,
  ListItemIcon,
  Box,
} from "@mui/material";
import { Logout, AccountCircle, TabletAndroid } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const AvatarComponent = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const navigate = useNavigate();
  const { user } = useAuth();
  var name = (user?.first_name || "") + " " + (user?.last_name || "");
  var role = "";
  if (user?.roles.some((role: any) => role.name === "Clinic") || null) {
    role = "Clinic";
  } else {
    role = user?.roles[0]?.name || "";
  }

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    navigate("/logout/");
    handleMenuClose();
  };

  const handleAccountOpen = () => {
    if (role.toLowerCase() === "admin") {
      navigate("/admin-section/settings");
    } else {
      navigate("/account");
    }
    handleMenuClose();
  };
  const handleOpenKiosk = () => {
    navigate("/kiosk-mode");
    handleMenuClose();
  };

  return (
    <div>
      {/* Avatar (clickable) */}
      <IconButton onClick={handleMenuOpen} color="inherit">
        <Avatar
          alt="User Name"
          src="/path-to-avatar.jpg"
          sx={{ bgcolor: "green", width: 40, height: 40 }}
        />
      </IconButton>

      {/* Dropdown (Menu) */}
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          mt: 1,
          "& .MuiPaper-root": {
            borderRadius: 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            padding: 1,
            minWidth: 200,
          },
        }}
      >
        <MenuItem
          onClick={handleAccountOpen}
          sx={{
            alignItems: "flex-start",
            px: 2,
          }}
        >
          <Box ml={1}>
            {/* Username */}
            <Typography variant="body1" fontWeight="bold" color="text.primary">
              {name}
            </Typography>
            {/* Role */}
            <Typography variant="body2" color="text.secondary">
              {role}
            </Typography>
          </Box>
        </MenuItem>

        {role === "Clinic" && (
          <MenuItem onClick={handleOpenKiosk} sx={{ px: 2 }}>
            <ListItemIcon>
              <TabletAndroid fontSize="small" sx={{ color: "#f16e5f" }} />
            </ListItemIcon>
            <Typography variant="body1" color="text.primary">
              Kiosk Mode
            </Typography>
          </MenuItem>
        )}

        <MenuItem onClick={handleLogout} sx={{ px: 2 }}>
          <ListItemIcon>
            <Logout fontSize="small" sx={{ color: "#f16e5f" }} />
          </ListItemIcon>
          <Typography variant="body1" color="text.primary">
            Logout
          </Typography>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default AvatarComponent;
